import React from 'react';
import '../template-file-css/document-file-template.css';


export const MMBHC_BehavioralHealthAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='MMBHC_BehavioralHealthAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>BEHAVIORAL HEALTH HISTORY</p>
                <p className='w-750'><span className='eleHeader'>I. CHIEF COMPLAINT </span><span className='small'>(Major symptoms, difficulties, and/or issues as they relate to behavioral health-in the client's/caretaker's own words/quoted.)</span></p>
                <p className='w-750'>
                    <textarea id='txtBehavioralHealthHistory' name='txtBehavioralHealthHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>II. PRESENTING PROBLEM/RELEVANT HISTORY</span><span className='small'> (Including client/caretaker/guardian reason for seeking services, precipitating factors, symptoms, behavioral and functioning impacts, onset/course of issues, current behavioral health providers, services sought and expectations.)</span></p>

                <table>
                    <tr>
                        <td className='w-500'>CURRENT BEHAVIORAL HEALTH PROVIDER NAME: </td>
                        <td className='w-250'>PHONE NUMBER: </td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='txtHealthProviderName' name='txtHealthProviderName' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>1. Referral Source: </span></td>
                        <td className='w-375'><span className='eleHeader'>2. Onset/course of issues:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtReferralSource' name='txtReferralSource' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtCourseOfIssues' name='txtCourseOfIssues' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>3. Symptoms: </span></td>
                        <td className='w-375'><span className='eleHeader'>4. As evidenced by:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtSymptoms' name='txtSymptoms' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtAsEvidencedBy' name='txtAsEvidencedBy' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>5. Frequency: </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFrequency' name='txtFrequency' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>a. Functional impacts of symptoms: </b>
                            <input type='text' id='txtFrequency' name='txtFrequency' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>b. Emotional response: </b>
                            <input type='text' id='txtEmotionalResponse' name='txtEmotionalResponse' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>c. Mood changes: </b>
                            <input type='text' id='txtMoodChanges' name='txtMoodChanges' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>d. Pervasive and persistent emotional distress: </b>
                            <input type='text' id='txtEmotionalDistress' name='txtEmotionalDistress' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>e. Dangerous, specify and in the context in which it occurs: </b>
                            <input type='text' id='txtDangerousSpecify' name='txtDangerousSpecify' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'>1. Self:
                            <input type='text' id='txtDangerousSpecifySelf' name='txtDangerousSpecifySelf' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>2. Others:
                            <input type='text' id='txtDangerousSpecifyOthers' name='txtDangerousSpecifyOthers' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>3. Property:
                            <input type='text' id='txtDangerousSpecifyProperty' name='txtDangerousSpecifyProperty' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>f. Presence of eating disorder and/or somatic disorder, specify: </b>
                            <input type='text' id='txtEatingDisorder' name='txtEatingDisorder' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>g. Disruptive disorder: </b>
                            <input type='text' id='txtDisruptiveDisorder' name='txtDisruptiveDisorder' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>6. Suicide attempt dates, method, treatment obtained, cause of attempt: </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSuicideAttempt' name='txtSuicideAttempt' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>7. Precipitating circumstances, stressors, or conflicts: </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPrecipitatingCircumstances' name='txtPrecipitatingCircumstances' className='add-only' /></td>
                    </tr>

                    <p className='w-750'><h3>Family or significant other's description of the problem</h3></p>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>8. Are you sexually active? </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSexuallyActiveYes' name='rbSexuallyActive' className='add-only' value='SexuallyActiveYes' /> Yes &nbsp;
                            <input type='radio' id='rbSexuallyActiveNo' name='rbSexuallyActive' className='add-only' value='SexuallyActiveNo' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>9. Are you current on all immunizations? </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbImmunizationsYes' name='rbImmunizations' className='add-only' value='ImmunizationsYes' /> Yes &nbsp;
                            <input type='radio' id='rbImmunizationsNo' name='rbImmunizations' className='add-only' value='ImmunizationsNo' /> No
                        </td>
                    </tr>




                </table>


                <table>
                    <tr>
                        <td className='w-750'>III. PAST PSYCHIATRIC/PLACEMENT HISTORY <span className='small'>(First onset of illness, past diagnostic and treatment history, medications, and hospitalizations):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Prior Outpatient Mental Health Treatment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMentalHealthTreatmentYes' name='rbMentalHealthTreatment' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealthTreatmentNo' name='rbMentalHealthTreatment' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Details: <input type='text' id='txtMentalHealthTreatment' name='txtMentalHealthTreatment' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Psychiatric Hospitalizations:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbPsychiatricHospitalizationsYes' name='rbPsychiatricHospitalizations' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPsychiatricHospitalizationsNo' name='rbPsychiatricHospitalizations' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Details: <input type='text' id='txtPsychiatricHospitalizations' name='txtPsychiatricHospitalizations' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Prior Residential/Out of Home Placement:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHomePlacementYes' name='rbHomePlacement' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHomePlacementNo' name='rbHomePlacement' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Details: <input type='text' id='txtHomePlacement' name='txtHomePlacement' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Additional Family History of Mental Disorders/Comments:</span></p>
                <p className='w-750'>
                    <textarea id='txtAdditionalFamilyHistory' name='txtAdditionalFamilyHistory' className='add-only '></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>IV. SUBSTANCE ABUSE/DEPENDENCE <span className='small'>(Past use of primary, secondary & tertiary current substance, including type, freq., method & age of first use.)</span></td>
                    </tr>
                </table>

                <p className='w-750'><center>SECTION A-Screening Questions</center></p>
                <p className='w-750'><span className='small'>(All Recipients (e.g., ages 10 and older) should complete this section “Screening Questions.” If a “Yes” is answered on one or more questions, the provider should ensure a more detailed substance abuse assessment is arranged.)</span></p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>1. Have your parents, family, partner, co-workers, classmates or friends complained about your alcohol, marijuana or other drug use?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbComplainedDrugUseYes' name='rbComplainedDrugUse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbComplainedDrugUseNo' name='rbComplainedDrugUse' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>2. Have you used alcohol, marijuana, or other drugs weekly?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWeeklyDrugUseYes' name='rbWeeklyDrugUse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWeeklyDrugUseNo' name='rbWeeklyDrugUse' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>3. Have you kept using alcohol, marijuana, or other drugs even after you knew it could get you into fights or other kinds of legal trouble?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbLegalTroubleYes' name='rbLegalTrouble' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLegalTroubleNo' name='rbLegalTrouble' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>4. Have you spent a lot of time getting alcohol, marijuana or other drugs, using them or feeling the effects of them (high, sick)?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTimeWithoutDrugYes' name='rbTimeWithoutDrug' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTimeWithoutDrugNo' name='rbTimeWithoutDrug' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>5. Have you ever had a drink or used drugs first thing in the morning to steady your nerves or to get rid of a hangover?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHangoverYes' name='rbHangover' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHangoverNo' name='rbHangover' className='add-only' value='No' /> No
                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><center>Disposition</center></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNoSubstanceAbuse' name='cbNoSubstanceAbuse' className='add-only' value='NoSubstanceAbuse' /> No substance abuse issues indicated by answers to screening questions.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdditionalSubstanceAbuse' name='cbAdditionalSubstanceAbuse' className='add-only' value='AdditionalSubstanceAbuse' /> Additional substance abuse assessment indicated person to be referred for further assessment.
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-450'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-450'> Referred to:</td>
                        <td className='small w-250'> Referred Date: </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Substance Abuse Treatment History:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSubstanceAbuseTreatmentHistoryNone' name='rbSubstanceAbuseTreatmentHistory' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbSubstanceAbuseTreatmentHistoryOutpatient' name='rbSubstanceAbuseTreatmentHistory' className='add-only' value='Outpatient' /> Outpatient
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbSubstanceAbuseTreatmentHistoryIntensiveOutpatient' name='rbSubstanceAbuseTreatmentHistory' className='add-only' value='IntensiveOutpatient' /> Intensive Outpatient
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbSubstanceAbuseTreatmentHistoryDetox' name='rbSubstanceAbuseTreatmentHistory' className='add-only' value='Detox' /> Detox
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSubstanceAbuseTreatmentHistoryResidentialInpatient' name='rbSubstanceAbuseTreatmentHistory' className='add-only' value='ResidentialInpatient' /> Residential/Inpatient
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSubstanceAbuseTreatmentHistoryOtherDescribe' name='rbSubstanceAbuseTreatmentHistory' className='add-only' value='SubstanceAbuseTreatmentHistoryOtherDescribe' />  Other/Describe:
                            <input type='text' id='txtSubstanceAbuseTreatmentHistoryOtherDescribe' name='txtSubstanceAbuseTreatmentHistoryOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>SUBSTANCE TYPE</h3></p>


                <table>


                    <tr>
                        <td className='w-750'><b>1. Alcohol/beer/wine</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_1FirstUse_1' name='txtSubstance_1FirstUse_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_1Lifetime_1' name='txtSubstance_1Lifetime_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_1PastDays_1' name='txtSubstance_1PastDays_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_1LastUse_1' name='txtSubstance_1LastUse_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_1Amount_1' name='txtSubstance_1Amount_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_1' name='cbOral_1' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_1' name='cbNasal_1' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_1' name='cbSmoking_1' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_1' name='cbNonIv_1' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_1' name='cbIv_1' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>2. Marijuana </b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_2FirstUse_2' name='txtSubstance_2FirstUse_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_2Lifetime_2' name='txtSubstance_2Lifetime_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_2PastDays_2' name='txtSubstance_2PastDays_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_2LastUse_2' name='txtSubstance_2LastUse_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_2Amount_2' name='txtSubstance_2Amount_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_2' name='cbOral_2' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_2' name='cbNasal_2' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_2' name='cbSmoking_2' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_2' name='cbNonIv_2' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_2' name='cbIv_2' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>3. Hashish</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_3FirstUse_3' name='txtSubstance_3FirstUse_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_3Lifetime_3' name='txtSubstance_3Lifetime_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_3PastDays_3' name='txtSubstance_3PastDays_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_3LastUse_3' name='txtSubstance_3LastUse_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_3Amount_3' name='txtSubstance_3Amount_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_3' name='cbOral_3' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_3' name='cbNasal_3' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_3' name='cbSmoking_3' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_3' name='cbNonIv_3' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_3' name='cbIv_3' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>4. Amphetamine/Methamphetamine</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_4FirstUse_4' name='txtSubstance_4FirstUse_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_4Lifetime_4' name='txtSubstance_4Lifetime_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_4PastDays_4' name='txtSubstance_4PastDays_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_4LastUse_4' name='txtSubstance_4LastUse_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_4Amount_4' name='txtSubstance_4Amount_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_4' name='cbOral_4' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_4' name='cbNasal_4' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_4' name='cbSmoking_4' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_4' name='cbNonIv_4' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_4' name='cbIv_4' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>5. Sleep Medication</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_5FirstUse_5' name='txtSubstance_5FirstUse_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_5Lifetime_5' name='txtSubstance_5Lifetime_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_5PastDays_5' name='txtSubstance_5PastDays_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_5LastUse_5' name='txtSubstance_5LastUse_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_5Amount_5' name='txtSubstance_5Amount_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_5' name='cbOral_5' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_5' name='cbNasal_5' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_5' name='cbSmoking_5' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_5' name='cbNonIv_5' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_5' name='cbIv_5' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>6. Hallucinogens</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_6FirstUse_6' name='txtSubstance_6FirstUse_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_6Lifetime_6' name='txtSubstance_6Lifetime_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_6PastDays_6' name='txtSubstance_6PastDays_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_6LastUse_6' name='txtSubstance_6LastUse_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_6Amount_6' name='txtSubstance_6Amount_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_6' name='cbOral_6' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_6' name='cbNasal_6' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_6' name='cbSmoking_6' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_6' name='cbNonIv_6' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_6' name='cbIv_6' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>7. Inhalants</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_7FirstUse_7' name='txtSubstance_7FirstUse_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_7Lifetime_7' name='txtSubstance_7Lifetime_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_7PastDays_7' name='txtSubstance_7PastDays_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_7LastUse_7' name='txtSubstance_7LastUse_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_7Amount_7' name='txtSubstance_7Amount_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_7' name='cbOral_7' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_7' name='cbNasal_7' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_7' name='cbSmoking_7' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_7' name='cbNonIv_7' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_7' name='cbIv_7' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>8. Cocaine/Crack</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_8FirstUse_8' name='txtSubstance_8FirstUse_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_8Lifetime_8' name='txtSubstance_8Lifetime_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_8PastDays_8' name='txtSubstance_8PastDays_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_8LastUse_8' name='txtSubstance_8LastUse_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_8Amount_8' name='txtSubstance_8Amount_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_8' name='cbOral_8' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_8' name='cbNasal_8' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_8' name='cbSmoking_8' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_8' name='cbNonIv_8' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_8' name='cbIv_8' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>9. Heroin</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_9FirstUse_9' name='txtSubstance_9FirstUse_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_9Lifetime_9' name='txtSubstance_9Lifetime_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_9PastDays_9' name='txtSubstance_9PastDays_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_9LastUse_9' name='txtSubstance_9LastUse_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_9Amount_9' name='txtSubstance_9Amount_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_9' name='cbOral_9' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_9' name='cbNasal_9' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_9' name='cbSmoking_9' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_9' name='cbNonIv_9' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_9' name='cbIv_9' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>10. Pain Medication (opioid)</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_10FirstUse_10' name='txtSubstance_10FirstUse_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_10Lifetime_10' name='txtSubstance_10Lifetime_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_10PastDays_10' name='txtSubstance_10PastDays_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_10LastUse_10' name='txtSubstance_10LastUse_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_10Amount_10' name='txtSubstance_10Amount_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_10' name='cbOral_10' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_10' name='cbNasal_10' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_10' name='cbSmoking_10' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_10' name='cbNonIv_10' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_10' name='cbIv_10' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>11. Tranquilizers</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_11FirstUse_11' name='txtSubstance_11FirstUse_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_11Lifetime_11' name='txtSubstance_11Lifetime_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_11PastDays_11' name='txtSubstance_11PastDays_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_11LastUse_11' name='txtSubstance_11LastUse_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_11Amount_11' name='txtSubstance_11Amount_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_11' name='cbOral_11' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_11' name='cbNasal_11' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_11' name='cbSmoking_11' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_11' name='cbNonIv_11' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_11' name='cbIv_11' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>12. Other (specify)</b>
                            <input type='text' id='txtSubstance_12Other_1' name='txtSubstance_12Other_1' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_12FirstUse_12' name='txtSubstance_12FirstUse_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_12Lifetime_12' name='txtSubstance_12Lifetime_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_12PastDays_12' name='txtSubstance_12PastDays_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_12LastUse_12' name='txtSubstance_12LastUse_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_12Amount_12' name='txtSubstance_12Amount_12' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_12' name='cbOral_12' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_12' name='cbNasal_12' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_12' name='cbSmoking_12' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_12' name='cbNonIv_12' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_12' name='cbIv_12' className='add-only' value='Iv' /> IV</td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>13. Other (specify)</b>
                            <input type='text' id='txtSubstance_13Other_2' name='txtSubstance_13Other_2' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>AGE OF 1ST USE </span></td>
                        <td className='w-150'><span className='eleHeader'>YEARS IN LIFETIME </span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS IN PAST 30 DAYS</span></td>
                        <td className='w-150'><span className='eleHeader'>DAYS SINCE LAST USE</span></td>
                        <td className='w-150'><span className='eleHeader'>AMOUNT</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSubstance_13FirstUse_13' name='txtSubstance_13FirstUse_13' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_13Lifetime_13' name='txtSubstance_13Lifetime_13' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_13PastDays_13' name='txtSubstance_13PastDays_13' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_13LastUse_13' name='txtSubstance_13LastUse_13' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSubstance_13Amount_13' name='txtSubstance_13Amount_13' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>ROUTE OF ADMINISTRATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbOral_13' name='cbOral_13' className='add-only' value='Oral' /> Oral</td>
                        <td className='w-150'><input type='checkbox' id='cbNasal_13' name='cbNasal_13' className='add-only' value='Nasal' /> Nasal</td>
                        <td className='w-150'><input type='checkbox' id='cbSmoking_13' name='cbSmoking_13' className='add-only' value='Smoking' /> Smoking</td>
                        <td className='w-150'><input type='checkbox' id='cbNonIv_13' name='cbNonIv_13' className='add-only' value='NonIv' /> Non-IV</td>
                        <td className='w-150'><input type='checkbox' id='cbIv_13' name='cbIv_13' className='add-only' value='Iv' /> IV</td>
                    </tr>
                </table>
                <p className='w-750'>Comments/Details</p>
                <p className='w-750'>
                    <textarea id='txtSubstanceComment' name='txtSubstanceComment' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>V. CURRENT MEDICAL CONDITIONS <span className='small'> (Check all that apply)</span></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPregnant' name='cbPregnant' className='add-only' value='Pregnant' /> Pregnant &nbsp;
                            <input type='date' id='txtPregnant' name='txtPregnant' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbNoneReported' name='cbNoneReported' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbAsthma' name='cbAsthma' className='add-only' value='Asthma' /> Asthma</td>
                        <td className='w-250'><input type='checkbox' id='cbSeizure' name='cbSeizure' className='add-only' value='Seizure' /> Seizure</td>
                    </tr>

                    <tr>

                        <td className='w-250'><input type='checkbox' id='cbCancer' name='cbCancer' className='add-only' value='Cancer' /> Cancer</td>
                        <td className='w-250'><input type='checkbox' id='cbUnderweight' name='cbUnderweight' className='add-only' value='Underweight' /> Underweight</td>
                        <td className='w-250'><input type='checkbox' id='cbStroke' name='cbStroke' className='add-only' value='Stroke' /> Stroke</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEmphysema' name='cbEmphysema' className='add-only' value='Emphysema' /> Emphysema</td>
                        <td className='w-250'><input type='checkbox' id='cbCirrhosis' name='cbCirrhosis' className='add-only' value='Cirrhosis' /> Cirrhosis</td>
                        <td className='w-250'><input type='checkbox' id='cbChronicPain' name='cbChronicPain' className='add-only' value='ChronicPain' /> Chronic Pain</td>
                    </tr>

                    <tr>

                        <td className='w-250'><input type='checkbox' id='cbOverweight' name='cbOverweight' className='add-only' value='Overweight' /> Overweight</td>
                        <td className='w-250'><input type='checkbox' id='cbHeartDisease' name='cbHeartDisease' className='add-only' value='HeartDisease' /> Heart Disease</td>
                        <td className='w-250'><input type='checkbox' id='cbDiabetes' name='cbDiabetes' className='add-only' value='Diabetes' /> Diabetes</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEpilepsy' name='cbEpilepsy' className='add-only' value='Epilepsy' /> Epilepsy</td>
                        <td className='w-250'><input type='checkbox' id='cbThyroidDisease' name='cbThyroidDisease' className='add-only' value='ThyroidDisease' /> Thyroid Disease</td>
                        <td className='w-250'><input type='checkbox' id='cbCongestiveHeartFailure' name='cbCongestiveHeartFailure' className='add-only' value='CongestiveHeartFailure' /> Congestive Heart Failure</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHighBloodPressure' name='cbHighBloodPressure' className='add-only' value='HighBloodPressure' /> High Blood Pressure</td>
                        <td className='w-250'><input type='checkbox' id='cbDigestiveProblems' name='cbDigestiveProblems' className='add-only' value='DigestiveProblems' /> Digestive Problems</td>
                        <td className='w-250'><input type='checkbox' id='cbSexuallyTransmittedDisease' name='cbSexuallyTransmittedDisease' className='add-only' value='SexuallyTransmittedDisease' /> Sexually Transmitted Disease</td>
                    </tr>

                    <tr>
                        <td className='w-750'>Comments/Details: <input type='text' id='txt' name='txt' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'>A. CURRENT & PAST MEDICATIONS<span className='small'> (Including non-psychotropic medication.) Identify the medications that you are currently taking for medical behavioral health concerns, and the reason for taking the medications, below:</span></p>

                <table>


                    <tr>
                        <td className='w-500'><span className='eleHeader'>1. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'><input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDose_1' name='txtDose_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Route</span></td>
                        <td className='w-250'><span className='eleHeader'>Current</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtRoute_1' name='txtRoute_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbCurrent_1Yes' name='rbCurrent_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrent_1No' name='rbCurrent_1' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>COMMENTS <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            <input type='text' id='txtCurrentComment_1' name='txtCurrentComment_1' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-500'><span className='eleHeader'>2. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'><input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDose_2' name='txtDose_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Route</span></td>
                        <td className='w-250'><span className='eleHeader'>Current</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtRoute_2' name='txtRoute_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbCurrent_2Yes' name='rbCurrent_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrent_2No' name='rbCurrent_2' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>COMMENTS <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            <input type='text' id='txtCurrentComment_2' name='txtCurrentComment_2' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-500'><span className='eleHeader'>3. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'><input type='text' id='txtMedicationName_3' name='txtMedicationName_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDose_3' name='txtDose_3' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Route</span></td>
                        <td className='w-250'><span className='eleHeader'>Current</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtRoute_3' name='txtRoute_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbCurrent_3Yes' name='rbCurrent_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrent_3No' name='rbCurrent_3' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>COMMENTS <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            <input type='text' id='txtCurrentComment_3' name='txtCurrentComment_3' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-500'><span className='eleHeader'>4. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'><input type='text' id='txtMedicationName_4' name='txtMedicationName_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDose_4' name='txtDose_4' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Route</span></td>
                        <td className='w-250'><span className='eleHeader'>Current</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtRoute_4' name='txtRoute_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbCurrent_4Yes' name='rbCurrent_4' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrent_4No' name='rbCurrent_4' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>COMMENTS <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            <input type='text' id='txtCurrentComment_4' name='txtCurrentComment_4' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-500'><span className='eleHeader'>5. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'><input type='text' id='txtMedicationName_5' name='txtMedicationName_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDose_5' name='txtDose_5' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Route</span></td>
                        <td className='w-250'><span className='eleHeader'>Current</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtRoute_5' name='txtRoute_5' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbCurrent_5Yes' name='rbCurrent_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrent_5No' name='rbCurrent_5' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>COMMENTS <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            <input type='text' id='txtCurrentComment_5' name='txtCurrentComment_5' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-500'><span className='eleHeader'>6. Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'><input type='text' id='txtMedicationName_6' name='txtMedicationName_6' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDose_6' name='txtDose_6' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Route</span></td>
                        <td className='w-250'><span className='eleHeader'>Current</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtRoute_6' name='txtRoute_6' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbCurrent_6Yes' name='rbCurrent_6' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrent_6No' name='rbCurrent_6' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>COMMENTS <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            <input type='text' id='txtCurrentComment_6' name='txtCurrentComment_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>B. ALLERGIES</span></p>
                <p className='w-750'>
                    <input type='radio' id='rbReportedDrugNo' name='rbReportedDrug' className='add-only' value='' /> No Reported Drug or Food Allergies &nbsp;

                </p>
                <p className='w-750'>
                    <input type='radio' id='rbReportedDrugOther' name='rbReportedDrug' className='add-only' value='' /> Other/Describe :
                    <input type='text' id='txtReportedDrugDescribe' name='txtReportedDrugDescribe' className='add-only w-350 custom-add-only' />
                </p>

                <p className='w-750'>C. PRIMARY CARE PHYSICIAN</p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Phone</span></td>
                        <td className='w-250'><span className='eleHeader'>Fax</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPhone' name='txtPhone' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtFax' name='txtFax' className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'>D. ADDITIONAL SIGNIFICANT MEDICAL HISTORY <span className='small'>(Diagnosis, Hospitalizations, surgery, Lab values, Status of Conditions, etc.)</span></p>
                <p className='w-750'>
                    <textarea id='txtAdditionalSignificant' name='txtAdditionalSignificant' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>SOCIAL</h3></center></p>
                <p className='w-750'>VI. RECIPIENT'S LEGAL STATUS</p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>A. Current Legal Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalNone' name='cbCurrentLegalNone' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalProbation' name='cbCurrentLegalProbation' className='add-only' value='Probation' /> Probation</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalChargesPending' name='cbCurrentLegalChargesPending' className='add-only' value='ChargesPending' /> Charges Pending</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalDcfs' name='cbCurrentLegalDcfs' className='add-only' value='Dcfs' /> DCFS</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalOjj' name='cbCurrentLegalOjj' className='add-only' value='Ojj' /> OJJ</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalFins' name='cbCurrentLegalFins' className='add-only' value='Fins' /> FINS</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalTruancy' name='cbCurrentLegalTruancy' className='add-only' value='Truancy' /> Truancy</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentLegalOther' name='cbCurrentLegalOther' className='add-only' value='Other' /> Other</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Comment/Details:
                            <input type='text' id='txtCurrentLegalDescribe' name='txtCurrentLegalDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>B. Past Legal Status/History:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPastLegalNone' name='cbPastLegalNone' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='checkbox' id='cbPastLegalProbation' name='cbPastLegalProbation' className='add-only' value='Probation' /> Probation</td>
                        <td className='w-187'><input type='checkbox' id='cbPastLegalDcfs' name='cbPastLegalDcfs' className='add-only' value='Dcfs' /> DCFS</td>
                        <td className='w-187'><input type='checkbox' id='cbPastLegalOjj' name='cbPastLegalOjj' className='add-only' value='Ojj' /> OJJ</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPastLegalFins' name='cbPastLegalFins' className='add-only' value='Fins' /> FINS</td>
                        <td className='w-187'><input type='checkbox' id='cbPastLegalTruancy' name='cbPastLegalTruancy' className='add-only' value='Truancy' /> Truancy</td>
                        <td className='w-187'><input type='checkbox' id='cbPastLegalOther' name='cbPastLegalOther' className='add-only' value='Other' /> Other</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Comment/Details:
                            <input type='text' id='txtPastLegalDescribe' name='txtPastLegalDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>C. History of Recipient/Recipient's Family involvement in any of the following legal issues: <span className='small'>(Check all that apply) </span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamilyInvolvementCustodyOrders' name='cbFamilyInvolvementCustodyOrders' className='add-only' value='CustodyOrders' /> Custody orders</td>
                        <td className='w-250'><input type='checkbox' id='cbFamilyInvolvementDomesticViolence' name='cbFamilyInvolvementDomesticViolence' className='add-only' value='DomesticViolence' /> Domestic violence</td>
                        <td className='w-250'><input type='checkbox' id='cbFamilyInvolvementProtectiveOrders' name='cbFamilyInvolvementProtectiveOrders' className='add-only' value='ProtectiveOrders' /> Protective orders</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamilyInvolvementDenialVisitations' name='cbFamilyInvolvementDenialVisitations' className='add-only' value='DenialVisitations' /> Denial of visitations</td>
                        <td className='w-250'><input type='checkbox' id='cbFamilyInvolvementSupervisedVisitation' name='cbFamilyInvolvementSupervisedVisitation' className='add-only' value='SupervisedVisitation' /> Supervised visitation</td>
                        <td className='w-250'><input type='checkbox' id='cbFamilyInvolvementGarnishmentWages' name='cbFamilyInvolvementGarnishmentWages' className='add-only' value='GarnishmentWages' /> Garnishment of wages</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFamilyInvolvementEvictionApartment' name='cbFamilyInvolvementEvictionApartment' className='add-only' value='EvictionApartment' /> Eviction from home or apartment</td>
                        <td className='w-500'><input type='checkbox' id='cbFamilyInvolvementFoundedNeglectAllegations' name='cbFamilyInvolvementFoundedNeglectAllegations' className='add-only' value='FoundedNeglectAllegations' /> Founded neglect or abuse allegations</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbFamilyInvolvementVoluntaryInvoluntary' name='cbFamilyInvolvementVoluntaryInvoluntary' className='add-only' value='VoluntaryInvoluntary' /> Voluntary or involuntary removal of family member from home</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Comment/Details:
                            <input type='text' id='txtFamilyInvolvementDescribe' name='txtFamilyInvolvementDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>VII. FAMILY HISTORY <span className='small'>(relationship status with relatives, family involvement in treatment, and living status of significant relative.)</span></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Custodial Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCustodialStatusIndependentAdult' name='cbCustodialStatusIndependentAdult' className='add-only' value='IndependentAdult' /> Independent Adult</td>
                        <td className='w-250'><input type='checkbox' id='cbCustodialStatusBiologicalFather' name='cbCustodialStatusBiologicalFather' className='add-only' value='BiologicalFather' /> Biological Father</td>
                        <td className='w-250'><input type='checkbox' id='cbCustodialStatusBiologicalMother' name='cbCustodialStatusBiologicalMother' className='add-only' value='BiologicalMother' /> Biological Mother</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCustodialStatusJointBiologicalParents' name='cbCustodialStatusJointBiologicalParents' className='add-only' value='JointBiologicalParents' /> Joint Biological Parents</td>
                        <td className='w-250'><input type='checkbox' id='cbCustodialStatusGovtJudicial' name='cbCustodialStatusGovtJudicial' className='add-only' value='GovtJudicial' /> Gov't/Judicial</td>
                        <td className='w-250'><input type='checkbox' id='cbCustodialStatusOther' name='cbCustodialStatusOther' className='add-only' value='Other' /> Other</td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Adverse Circumstances in Family of Origin</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesNa' name='cbAdverseCirsumstancesNa' className='add-only' value='Na' /> N/A</td>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesPoverty' name='cbAdverseCirsumstancesPoverty' className='add-only' value='Poverty' /> Poverty</td>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesCriminalBehavior' name='cbAdverseCirsumstancesCriminalBehavior' className='add-only' value='CriminalBehavior' /> Criminal Behavior</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesMentalIllness' name='cbAdverseCirsumstancesMentalIllness' className='add-only' value='MentalIllness' /> Mental Illness</td>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesSubstanceUse' name='cbAdverseCirsumstancesSubstanceUse' className='add-only' value='SubstanceUse' /> Substance Use</td>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesAbuse' name='cbAdverseCirsumstancesAbuse' className='add-only' value='Abuse' /> Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesNeglect' name='cbAdverseCirsumstancesNeglect' className='add-only' value='Neglect' /> Neglect</td>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesDomesticViolence' name='cbAdverseCirsumstancesDomesticViolence' className='add-only' value='DomesticViolence' /> Domestic Violence</td>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesViolence' name='cbAdverseCirsumstancesViolence' className='add-only' value='Violence' /> Violence</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAdverseCirsumstancesTrauma' name='cbAdverseCirsumstancesTrauma' className='add-only' value='Trauma' /> Trauma</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAdverseCirsumstancesOther' name='cbAdverseCirsumstancesOther' className='add-only' value='GovtJudicial' /> Other/Describe:
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>1. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_1' name='txtName_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_1' name='txtNatureOfRelationship_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_1' name='txtQualityOfRelationship_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_1Yes' name='rbResideInHome_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_1No' name='rbResideInHome_1' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_1Yes' name='rbMentalHealth_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_1No' name='rbMentalHealth_1' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_1Unknown' name='rbMentalHealth_1' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_1Yes' name='rbContact_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_1No' name='rbContact_1' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>2. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_2' name='txtName_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_2' name='txtNatureOfRelationship_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_2' name='txtQualityOfRelationship_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_2Yes' name='rbResideInHome_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_2No' name='rbResideInHome_2' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_2Yes' name='rbMentalHealth_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_2No' name='rbMentalHealth_2' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_2Unknown' name='rbMentalHealth_2' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_2Yes' name='rbContact_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_2No' name='rbContact_2' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>3. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_3' name='txtName_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_3' name='txtNatureOfRelationship_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_3' name='txtQualityOfRelationship_3' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_3Yes' name='rbResideInHome_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_3No' name='rbResideInHome_3' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_3Yes' name='rbMentalHealth_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_3No' name='rbMentalHealth_3' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_3Unknown' name='rbMentalHealth_3' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_3Yes' name='rbContact_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_3No' name='rbContact_3' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>4. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_4' name='txtName_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_4' name='txtNatureOfRelationship_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_4' name='txtQualityOfRelationship_4' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_4Yes' name='rbResideInHome_4' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_4No' name='rbResideInHome_4' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_4Yes' name='rbMentalHealth_4' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_4No' name='rbMentalHealth_4' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_4Unknown' name='rbMentalHealth_4' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_4Yes' name='rbContact_4' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_4No' name='rbContact_4' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>5. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_5' name='txtName_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_5' name='txtNatureOfRelationship_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_5' name='txtQualityOfRelationship_5' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_5Yes' name='rbResideInHome_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_5No' name='rbResideInHome_5' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_5Yes' name='rbMentalHealth_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_5No' name='rbMentalHealth_5' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_5Unknown' name='rbMentalHealth_5' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_5Yes' name='rbContact_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_5No' name='rbContact_5' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>6. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_6' name='txtName_6' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_6' name='txtNatureOfRelationship_6' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_6' name='txtQualityOfRelationship_6' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_6Yes' name='rbResideInHome_6' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_6No' name='rbResideInHome_6' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_6Yes' name='rbMentalHealth_6' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_6No' name='rbMentalHealth_6' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_6Unknown' name='rbMentalHealth_6' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_6Yes' name='rbContact_6' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_6No' name='rbContact_6' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>7. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_7' name='txtName_7' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_7' name='txtNatureOfRelationship_7' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_7' name='txtQualityOfRelationship_7' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_7Yes' name='rbResideInHome_7' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_7No' name='rbResideInHome_7' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_7Yes' name='rbMentalHealth_7' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_7No' name='rbMentalHealth_7' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_7Unknown' name='rbMentalHealth_7' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_7Yes' name='rbContact_7' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_7No' name='rbContact_7' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>8. Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Person/Nature of Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Quality of Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtName_8' name='txtName_8' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtNatureOfRelationship_8' name='txtNatureOfRelationship_8' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtQualityOfRelationship_8' name='txtQualityOfRelationship_8' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Reside in Home <br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Mental Health or Substance Abuse Problems</span></td>
                        <td className='w-250'><span className='eleHeader'>May we contact <span className='small'>(Must sign release of information)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbResideInHome_8Yes' name='rbResideInHome_8' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbResideInHome_8No' name='rbResideInHome_8' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMentalHealth_8Yes' name='rbMentalHealth_8' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealth_8No' name='rbMentalHealth_8' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalHealth_8Unknown' name='rbMentalHealth_8' className='add-only' value='Unknown' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbContact_8Yes' name='rbContact_8' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContact_8No' name='rbContact_8' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments/Details: </span>
                    <textarea id='txtFamilyHistoryComments' name='txtFamilyHistoryComments' className='add-only'></textarea>
                </p>


                <p className='w-750'>VIII. DEVELOPMENTAL HISTORY </p>
                <table>
                    <tr>
                        <td className='w-750'><b>A. Parental/Birth</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><h3>1. History of any birth abnormalities/developmental disabilities/delays: </h3></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(a) Any complications during pregnancy?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbComplicationsPregnancy_A_Yes' name='rbComplicationsPregnancy_A' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbComplicationsPregnancy_A_No' name='rbComplicationsPregnancy_A' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbComplicationsPregnancy_A_Unknown' name='rbComplicationsPregnancy_A' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Specify:
                            <input type='text' id='txtComplicationsPregnancy_A' name='txtComplicationsPregnancy_A' className='add-only w-350 custom-add-only' /></td>
                    </tr>



                    <tr>
                        <td className='w-750'><span className='eleHeader'>(b) Full term pregnancy?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFullPregnancy_B_Yes' name='rbFullPregnancy_B' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFullPregnancy_B_No' name='rbFullPregnancy_B' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbFullPregnancy_B_Unknown' name='rbFullPregnancy_B' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Specify:
                            <input type='text' id='txtFullPregnancy_B' name='txtFullPregnancy_B' className='add-only w-350 custom-add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>(c) Use tobacco, illicit drugs, alcohol or medications?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAlcoholOrMedications_C_Yes' name='rbAlcoholOrMedications_C' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAlcoholOrMedications_C_No' name='rbAlcoholOrMedications_C' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAlcoholOrMedications_C_Unknown' name='rbAlcoholOrMedications_C' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Specify:
                            <input type='text' id='txtAlcoholOrMedications_C' name='txtAlcoholOrMedications_C' className='add-only w-350 custom-add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>(d) Experience complications during labor delivery?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbLaborDelivery_Yes' name='rbLaborDelivery' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLaborDelivery_No' name='rbLaborDelivery' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbLaborDelivery_Unknown' name='rbLaborDelivery' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Specify:
                            <input type='text' id='txtLaborDelivery' name='txtLaborDelivery' className='add-only w-350 custom-add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>(e) Have any medical or emotional problems?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMedicalEmotionalProblem_Yes' name='rbMedicalEmotionalProblem' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalEmotionalProblem_No' name='rbMedicalEmotionalProblem' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMedicalEmotionalProblem_Unknown' name='rbMedicalEmotionalProblem' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Specify:
                            <input type='text' id='txtMedicalEmotionalProblem' name='txtMedicalEmotionalProblem' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h3>2. Timing of Developmental Milestones</h3></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>(a) By 0-1 year of age, has the Recipient:</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Sat up?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSatUp_Yes' name='rbSatUp' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSatUp_No' name='rbSatUp' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbSatUp_Unknown' name='rbSatUp' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Crawled?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCrawled_Yes' name='rbCrawled' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCrawled_No' name='rbCrawled' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbCrawled_Unknown' name='rbCrawled' className='add-only' value='Unknown' /> Unknown
                        </td>


                    </tr>
                    <tr>
                        <td className='w-750'><b>(b) By 1-3 year of age, has the Recipient:</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Walked alone?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWalkedAlone_Yes' name='rbWalkedAlone' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWalkedAlone_No' name='rbWalkedAlone' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbWalkedAlone_Unknown' name='rbWalkedAlone' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Used first words?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbUsedWords_Yes' name='rbUsedWords' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbUsedWords_No' name='rbUsedWords' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbUsedWords_Unknown' name='rbUsedWords' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Fed self with spoon?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFedSelfWithSpoon_Yes' name='rbFedSelfWithSpoon' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFedSelfWithSpoon_No' name='rbFedSelfWithSpoon' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbFedSelfWithSpoon_Unknown' name='rbFedSelfWithSpoon' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'><b>(c) By 3-5 year of age, has the Recipient:</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Been toilet trained?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbToiletTrained_Yes' name='rbToiletTrained' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbToiletTrained_No' name='rbToiletTrained' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbToiletTrained_Unknown' name='rbToiletTrained' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Used first sentenced?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFirstSentenced_Yes' name='rbFirstSentenced' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFirstSentenced_No' name='rbFirstSentenced' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbFirstSentenced_Unknown' name='rbFirstSentenced' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Learned to ride a tricycle?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbRideTricycle_Yes' name='rbRideTricycle' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbRideTricycle_No' name='rbRideTricycle' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbRideTricycle_Unknown' name='rbRideTricycle' className='add-only' value='Unknown' /> Unknown
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h3>1. Other Developmental issues. Indicate below if the Recipient ever experienced any of the following: </h3></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(a) Could not gain weight</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCouldNotGainWeight_No' name='rbCouldNotGainWeight' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbCouldNotGainWeight_Yes' name='rbCouldNotGainWeight' className='add-only' value='Yes' /> Yes, age began &nbsp;
                            <input type='text' id='txtBeganCouldNotGainWeight' name='txtCouldNotGainWeight' className='add-only w-200 custom-add-only' /> and if resolved, when &nbsp;
                            <input type='text' id='txtResolvedCouldNotGainWeight' name='txtCouldNotGainWeight' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(b) Wet the bed or soiled his/her clothes</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWetTheBed_No' name='rbWetTheBed' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbWetTheBed_Yes' name='rbWetTheBed' className='add-only' value='Yes' /> Yes, age began &nbsp;
                            <input type='text' id='txtBeganWetTheBed' name='txtBeganWetTheBed' className='add-only w-200 custom-add-only' /> and if resolved, when &nbsp;
                            <input type='text' id='txtResolvedWetTheBed' name='txtResolvedWetTheBed' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(c) Had difficulty with coordination</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDifficultyCoordinating_No' name='rbDifficultyCoordinating' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDifficultyCoordinating_Yes' name='rbDifficultyCoordinating' className='add-only' value='Yes' /> Yes, age began &nbsp;
                            <input type='text' id='txtBeganDifficultyCoordinating' name='txtBeganDifficultyCoordinating' className='add-only w-200 custom-add-only' /> and if resolved, when &nbsp;
                            <input type='text' id='txtResolvedDifficultyCoordinating' name='txtResolvedDifficultyCoordinating' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(d) Had difficulty with speech</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDifficultyWithSpeech_No' name='rbDifficultyWithSpeech' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDifficultyWithSpeech_Yes' name='rbDifficultyWithSpeech' className='add-only' value='Yes' /> Yes, age began &nbsp;
                            <input type='text' id='txtBeganDifficultyWithSpeech' name='txtBeganDifficultyWithSpeech' className='add-only w-200 custom-add-only' /> and if resolved, when &nbsp;
                            <input type='text' id='txtResolvedDifficultyWithSpeech' name='txtResolvedDifficultyWithSpeech' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(e) Had unusual sensitivity to touch</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSenstivityToTouch_No' name='rbSenstivityToTouch' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbSenstivityToTouch_Yes' name='rbSenstivityToTouch' className='add-only' value='Yes' /> Yes, age began &nbsp;
                            <input type='text' id='txtBeganSenstivityToTouch' name='txtBeganSenstivityToTouch' className='add-only w-200 custom-add-only' /> and if resolved, when &nbsp;
                            <input type='text' id='txtResolvedSenstivityToTouch' name='txtResolvedSenstivityToTouch' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(f) Had difficulty with social skills</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDifficultySocialSkills_No' name='rbDifficultySocialSkills' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDifficultySocialSkills_Yes' name='rbDifficultySocialSkills' className='add-only' value='Yes' /> Yes, age began &nbsp;
                            <input type='text' id='txtBeganDifficultySocialSkills' name='txtBeganDifficultySocialSkills' className='add-only w-200 custom-add-only' /> and if resolved, when &nbsp;
                            <input type='text' id='txtResolvedDifficultySocialSkills' name='txtResolvedDifficultySocialSkills' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(g) Was evaluated for taking too much time to develop certain skills <span className='small'>(e.g., communicating, reading, spelling)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTakingTooMuchTime_No' name='rbTakingTooMuchTime' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbTakingTooMuchTime_Yes' name='rbTakingTooMuchTime' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTakingTooMuchTime_Unknown' name='rbTakingTooMuchTime' className='add-only' value='Unknown' /> Unknown &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(h) Was evaluated for speech and language delays?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbLanguageDelay_No' name='rbLanguageDelay' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbLanguageDelay_Yes' name='rbLanguageDelay' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLanguageDelay_Unknown' name='rbLanguageDelay' className='add-only' value='Unknown' /> Unknown &nbsp;
                        </td>
                    </tr>

                </table>

                <p className='w-750'><span className='eleHeader'>Comments/Details:  </span>
                    <textarea id='txtParentalComment' name='txtParentalComment' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>IX. TRAUMA HISTORY</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Trauma</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHistoryOfTraumaNone' name='cbHistoryOfTraumaNone' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='checkbox' id='cbHistoryOfTraumaExperienced' name='cbHistoryOfTraumaExperienced' className='add-only' value='Experienced' /> Experienced</td>
                        <td className='w-187'><input type='checkbox' id='cbHistoryOfTraumaWitnessed' name='cbHistoryOfTraumaWitnessed' className='add-only' value='Witnessed' /> Witnessed</td>
                        <td className='w-187'><input type='checkbox' id='cbHistoryOfTraumaAbuse' name='cbHistoryOfTraumaAbuse' className='add-only' value='Abuse' /> Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHistoryOfTraumaNeglect' name='cbHistoryOfTraumaNeglect' className='add-only' value='Neglect' /> Neglect</td>
                        <td className='w-187'><input type='checkbox' id='cbHistoryOfTraumaViolence' name='cbHistoryOfTraumaViolence' className='add-only' value='Violence' /> Violence</td>
                        <td className='w-187'><input type='checkbox' id='cbHistoryOfTraumaSexualAssault' name='cbHistoryOfTraumaSexualAssault' className='add-only' value='SexualAssault' /> Sexual Assault</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHistoryOfTraumaOther' name='cbHistoryOfTraumaOther' className='add-only' value='Other' /> Other/Describe:
                            <input type='text' id='txtHistoryOfTraumaOther' name='txtHistoryOfTraumaOther' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>Comments/Details:  </span>
                    <textarea id='txtHistoryOfTraumaComment' name='txtHistoryOfTraumaComment' className='add-only' ></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>X. LIVING SITUATION</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Primary Residence</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPrimaryResidenceParentGuardianHome' name='cbPrimaryResidenceParentGuardianHome' className='add-only' value='ParentGuardianHome' /> Parent/Guardian Home</td>
                        <td className='w-187'><input type='checkbox' id='cbPrimaryResidenceRelativeHome' name='cbPrimaryResidenceRelativeHome' className='add-only' value='RelativeHome' /> Relative's Home</td>
                        <td className='w-187'><input type='checkbox' id='cbPrimaryResidenceHomeless' name='cbPrimaryResidenceHomeless' className='add-only' value='Homeless' /> Homeless</td>
                        <td className='w-187'><input type='checkbox' id='cbPrimaryResidenceOutHomePlacement' name='cbPrimaryResidenceOutHomePlacement' className='add-only' value='OutHomePlacement' /> Out of Home Placement</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>How long at current address?</span></td>
                        <td className='w-375'><span className='eleHeader'>Family/Household Composition</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtCurrentAddress' name='txtCurrentAddress' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtHouseholdComposition' name='txtHouseholdComposition' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>Comments/Details:  </span>
                    <textarea id='txtHistoryOfTraumaComment' name='txtHistoryOfTraumaComment' className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>XI. EDUCATIONAL/EMPLOYMENT STATUS </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>A. Current Educational Placement/Employer:</span></td>
                        <td className='w-375'><span className='eleHeader'>Current or Highest Grade Completed/Degree:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtEducational' name='txtEducational' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtHighestGrade' name='txtHighestGrade' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Difficulties with Reading/Writing:</span></td>
                        <td className='w-375'><span className='eleHeader'>Estimated Literacy Level:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDifficultyReadingYes' name='rbDifficultyReading' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultyReadingNo' name='rbDifficultyReading' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'><input type='text' id='txtHighestGrade' name='txtHighestGrade' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Difficulties with Language:</span></td>
                        <td className='w-375'><span className='eleHeader'>Difficulties with Speech:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDifficultyLanguageYes' name='rbDifficultyLanguage' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultyLanguageNo' name='rbDifficultyLanguage' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbDifficultySpeechYes' name='rbDifficultySpeech' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultySpeechNo' name='rbDifficultySpeech' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Difficulties with Hearing:</span></td>
                        <td className='w-375'><span className='eleHeader'>Difficulties with Vision:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbDifficultyHearingYes' name='rbDifficultyHearing' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultyHearingNo' name='rbDifficultyHearing' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbDifficultyVisionYes' name='rbDifficultyVision' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultyVisionNo' name='rbDifficultyVision' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRegularEducation' name='cbRegularEducation' className='add-only' value='RegularEducation' />  Regular Education –- no supports</td>
                        <td className='w-250'><input type='checkbox' id='cbAlternativeSchool' name='cbAlternativeSchool' className='add-only' value='AlternativeSchool' /> Alternative School</td>
                        <td className='w-250'><input type='checkbox' id='cbGedProgramRegularEducation' name='cbGedProgramRegularEducation' className='add-only' value='GedProgramRegularEducation' /> GED Program Regular Education</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOutSchoolExpelled' name='cbOutSchoolExpelled' className='add-only' value='OutSchoolExpelled' />  Out of School—Expelled</td>
                        <td className='w-250'><input type='checkbox' id='cbCollegeRegularEducation' name='cbCollegeRegularEducation' className='add-only' value='CollegeRegularEducation' /> College Regular Education</td>
                        <td className='w-250'><input type='checkbox' id='cbSelfContainedSpecialEducation' name='cbSelfContainedSpecialEducation' className='add-only' value='SelfContainedSpecialEducation' /> Self Contained Special Education</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEducation' name='cbEducation' className='add-only' value='Education' />  504 Education</td>
                        <td className='w-250'><input type='checkbox' id='cbHomeBound' name='cbHomeBound' className='add-only' value='HomeBound' /> Home Bound</td>
                        <td className='w-250'><input type='checkbox' id='cbOutSchoolDropOut' name='cbOutSchoolDropOut' className='add-only' value=' OutSchoolDropOut' />  Out of School—Drop Out</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOutSchoolTruant' name='cbOutSchoolTruant' className='add-only' value='OutSchoolTruant' /> Out of School—Truant </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>B. School Behaviors </span><span className='small'>(Check all that apply)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbInSchoolSuspension' name='cbInSchoolSuspension' className='add-only' value=' InSchoolSuspension' />  In school suspension</td>
                        <td className='w-250'><input type='checkbox' id='cbOutSchoolSuspension' name='cbOutSchoolSuspension' className='add-only' value='OutSchoolSuspension' /> Out of school suspension</td>
                        <td className='w-250'><input type='checkbox' id='cbSchoolExpulsion' name='cbSchoolExpulsion' className='add-only' value='SchoolExpulsion' /> School expulsion</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTruancy' name='cbTruancy' className='add-only' value='Truancy' /> Truancy</td>
                        <td className='w-250'><input type='checkbox' id='cbAbsenteeism' name='cbAbsenteeism' className='add-only' value='Absenteeism' /> Absenteeism</td>
                        <td className='w-250'><input type='checkbox' id='cbFighting' name='cbFighting' className='add-only' value='Fighting' /> Fighting</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDestructionProperty' name='cbDestructionProperty' className='add-only' value='DestructionProperty' /> Destruction of property</td>
                        <td className='w-250'><input type='checkbox' id='cbCarryingWeapon' name='cbCarryingWeapon' className='add-only' value='CarryingWeapon' /> Carrying Weapon</td>
                        <td className='w-250'><input type='checkbox' id='cbCheating' name='cbCheating' className='add-only' value='Cheating' /> Cheating</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAcademicFailure' name='cbAcademicFailure' className='add-only' value='AcademicFailure' /> Academic failure</td>
                        <td className='w-250'><input type='checkbox' id='cbCarryingContraband' name='cbCarryingContraband' className='add-only' value='CarryingContraband' /> Carrying contraband</td>
                        <td className='w-250'><input type='checkbox' id='cbParticipatedSports' name='cbParticipatedSports' className='add-only' value='ParticipatedSports' /> Participated in school sports</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbGotAlongTeachers' name='cbGotAlongTeachers' className='add-only' value='GotAlongTeachers' /> Got along with teachers</td>
                        <td className='w-500'><input type='checkbox' id='cbParticipatedOtherActivities' name='cbParticipatedOtherActivities' className='add-only' value='ParticipatedOtherActivities' /> Participated in other extra-curricular Activities</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtSchoolBehaviorsOther' name='txtSchoolBehaviorsOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>C. Learning Needs/Perception of Education Experience</span><b>Comments/Details:</b>
                    <textarea id='txtLearningNeedsComments' name='txtLearningNeedsComments' className='add-only' ></textarea>
                </p>

                <p className='w-750'>XII. FINANCIAL</p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>1. Current Family Monthly Income</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFamilyMonthlyIncome' name='txtFamilyMonthlyIncome' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Source of Income </span><span className='small'>(check all that apply)</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSsi' name='cbSsi' className='add-only' value='Ssi' /> SSI</td>
                        <td className='w-250'><input type='checkbox' id='cbSsdi' name='cbSsdi' className='add-only' value='Ssdi' /> SSDI</td>
                        <td className='w-250'><input type='checkbox' id='cbVa' name='cbVa' className='add-only' value='Va' /> VA</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbWorkerCompensation' name='cbWorkerCompensation' className='add-only' value='WorkerCompensation' /> Worker's Compensation</td>
                        <td className='w-250'><input type='checkbox' id='cbUnemploymentBenefits' name='cbUnemploymentBenefits' className='add-only' value='UnemploymentBenefits' /> Unemployment Benefits</td>
                        <td className='w-250'><input type='checkbox' id='cbRentSubsidies' name='cbRentSubsidies' className='add-only' value='RentSubsidies' /> Rent Subsidies</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFoodStamps' name='cbFoodStamps' className='add-only' value='FoodStamps' /> Food stamps</td>
                        <td className='w-250'><input type='checkbox' id='cbHousingAssistance' name='cbHousingAssistance' className='add-only' value='HousingAssistance' /> Housing assistance/shelter</td>
                        <td className='w-250'><input type='checkbox' id='cbIncomeFromFamily' name='cbIncomeFromFamily' className='add-only' value='IncomeFromFamily' /> Income from family</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbTanf' name='cbTanf' className='add-only' value='Tanf' /> TANF</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Comments/Details:</span>
                    <textarea id='txtSourceIncomeComments' name='txtSourceIncomeComments' className='add-only' ></textarea>
                </p>

                <p className='w-750'>XIII. LEISURE/RECREATIONAL</p>
                <p className='w-750'><span className='eleHeader'>1. Recreational Activities</span>
                    <textarea id='txtRecreationalActivities' name='txtRecreationalActivities' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>2. Self-help Activities</span>
                    <textarea id='txtSelfhelpActivities' name='txtSelfhelpActivities' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Comments/Details:</span>
                    <textarea id='txtLeisureComments' name='txtLeisureComments' className='add-only' ></textarea>
                </p>

                <p className='w-750'>XIII. MENTAL STATUS EXAMINATION <span className='small'>(Circle or check all that apply.) A Mental Status Exam and Treatment History is a standard requirement of the Eligibility Clinical Evaluation and MSE must be based on a face-to-face interview </span></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. GENERAL APPEARANCE</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHealthy' name='cbHealthy' className='add-only' value='Healthy' /> Healthy</td>
                        <td className='w-187'><input type='checkbox' id='cbAsStatedAge' name='cbAsStatedAge' className='add-only' value='AsStatedAge' /> As stated Age</td>
                        <td className='w-187'><input type='checkbox' id='cbOlderThanStatedAge' name='cbOlderThanStatedAge' className='add-only' value='OlderThanStatedAge' /> Older Than Stated Age</td>
                        <td className='w-187'><input type='checkbox' id='cbYoungLooking' name='cbYoungLooking' className='add-only' value='YoungLooking' /> Young-looking</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTattoos' name='cbTattoos' className='add-only' value='Tattoos' /> Tattoos</td>
                        <td className='w-187'><input type='checkbox' id='cbDisheveled' name='cbDisheveled' className='add-only' value='Disheveled' /> Disheveled</td>
                        <td className='w-187'><input type='checkbox' id='cbUnkempt' name='cbUnkempt' className='add-only' value='Unkempt' /> Unkempt</td>
                        <td className='w-187'><input type='checkbox' id='cbMalodorous' name='cbMalodorous' className='add-only' value='Malodorous' /> Malodorous</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbThin' name='cbThin' className='add-only' value='Thin' /> Thin</td>
                        <td className='w-187'><input type='checkbox' id='cbOverweight' name='cbOverweight' className='add-only' value='Overweight' /> Overweight</td>
                        <td className='w-187'><input type='checkbox' id='cbObese' name='cbObese' className='add-only' value='Obese' /> Obese</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAppearanceOther' name='cbAppearanceOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtAppearanceOther' name='txtAppearanceOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. BEHAVIOR & PSYCHOMOTOR ACTIVITY</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='checkbox' id='cbOveractive' name='cbOveractive' className='add-only' value='Overactive' /> Overactive</td>
                        <td className='w-187'><input type='checkbox' id='cbHypoactive' name='cbHypoactive' className='add-only' value='Hypoactive' /> Hypoactive</td>
                        <td className='w-187'><input type='checkbox' id='cbCatatonia' name='cbCatatonia' className='add-only' value='Catatonia' /> Catatonia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTremor' name='cbTremor' className='add-only' value='Tremor' /> Tremor</td>
                        <td className='w-187'><input type='checkbox' id='cbTics' name='cbTics' className='add-only' value='Tics' /> Tics</td>
                        <td className='w-187'><input type='checkbox' id='cbCombative' name='cbCombative' className='add-only' value='Combative' /> Combative</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbBehaviorActivityOther' name='cbBehaviorActivityOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtBehaviorActivityOther' name='txtBehaviorActivityOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>c. ATTITUDE</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOptimal' name='cbOptimal' className='add-only' value='Optimal' /> Optimal</td>
                        <td className='w-187'><input type='checkbox' id='cbConstructive' name='cbConstructive' className='add-only' value='Constructive' /> Constructive</td>
                        <td className='w-187'><input type='checkbox' id='cbMotivated' name='cbMotivated' className='add-only' value='Motivated' /> Motivated</td>
                        <td className='w-187'><input type='checkbox' id='cbObstructive' name='cbObstructive' className='add-only' value='Obstructive' /> Obstructive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAdversarial' name='cbAdversarial' className='add-only' value='Adversarial' /> Adversarial</td>
                        <td className='w-187'><input type='checkbox' id='cbInaccessible' name='cbInaccessible' className='add-only' value='Inaccessible' /> Inaccessible</td>
                        <td className='w-187'><input type='checkbox' id='cbCooperative' name='cbCooperative' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-187'><input type='checkbox' id='cbSeductive' name='cbSeductive' className='add-only' value='Seductive' /> Seductive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDefensive ' name='cbDefensive ' className='add-only' value='Defensive ' /> Defensive </td>
                        <td className='w-187'><input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='Hostile' /> Hostile</td>
                        <td className='w-187'><input type='checkbox' id='cbGuarded' name='cbGuarded' className='add-only' value='Guarded' /> Guarded</td>
                        <td className='w-187'><input type='checkbox' id='cbApathetic' name='cbApathetic' className='add-only' value='Apathetic' /> Apathetic</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAttitudeOther' name='cbAttitudeOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtAttitudeOther' name='txtAttitudeOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>d. SPEECH</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='checkbox' id='cbSpontaneous' name='cbSpontaneous' className='add-only' value='Spontaneous' /> Spontaneous</td>
                        <td className='w-187'><input type='checkbox' id='cbSlow' name='cbSlow' className='add-only' value='Slow' /> Slow</td>
                        <td className='w-187'><input type='checkbox' id='cbImpoverished' name='cbImpoverished' className='add-only' value='Impoverished' /> Impoverished</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHesitant' name='cbHesitant' className='add-only' value='Hesitant' /> Hesitant</td>
                        <td className='w-187'><input type='checkbox' id='cbMonotonous' name='cbMonotonous' className='add-only' value='Monotonous' /> Monotonous</td>
                        <td className='w-187'><input type='checkbox' id='cbSoftWhispered' name='cbSoftWhispered' className='add-only' value='SoftWhispered' /> Soft/Whispered</td>
                        <td className='w-187'><input type='checkbox' id='cbMumbled' name='cbMumbled' className='add-only' value='Mumbled' /> Mumbled</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbRapid' name='cbRapid' className='add-only' value='Rapid' /> Rapid</td>
                        <td className='w-187'><input type='checkbox' id='cbPressured' name='cbPressured' className='add-only' value='Pressured' /> Pressured</td>
                        <td className='w-187'><input type='checkbox' id='cbVerbose' name='cbVerbose' className='add-only' value='Verbose' /> Verbose</td>
                        <td className='w-187'><input type='checkbox' id='cbLoud' name='cbLoud' className='add-only' value='Loud' /> Loud</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSlurred' name='cbSlurred' className='add-only' value='Slurred' /> Slurred</td>
                        <td className='w-187'><input type='checkbox' id='cbImpediment' name='cbImpediment' className='add-only' value='Impediment' /> Impediment</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSpeechOther' name='cbSpeechOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtSpeechOther' name='txtSpeechOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>e. MOOD</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDysphoric ' name='cbDysphoric ' className='add-only' value='Dysphoric ' /> Dysphoric </td>
                        <td className='w-187'><input type='checkbox' id='cbEuthymic' name='cbEuthymic' className='add-only' value='Euthymic' /> Euthymic</td>
                        <td className='w-187'><input type='checkbox' id='cbExpansive' name='cbExpansive' className='add-only' value='Expansive' /> Expansive</td>
                        <td className='w-187'><input type='checkbox' id='cbIrritable' name='cbIrritable' className='add-only' value='Irritable' /> Irritable</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile</td>
                        <td className='w-187'><input type='checkbox' id='cbElevated' name='cbElevated' className='add-only' value='Elevated' /> Elevated</td>
                        <td className='w-187'><input type='checkbox' id='cbEuphoric' name='cbEuphoric' className='add-only' value='Euphoric' /> Euphoric</td>
                        <td className='w-187'><input type='checkbox' id='cbEcstatic' name='cbEcstatic' className='add-only' value='Ecstatic' /> Ecstatic</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDepressed' name='cbDepressed' className='add-only' value='Depressed' /> Depressed</td>
                        <td className='w-187'><input type='checkbox' id='cbGriefMourning' name='cbGriefMourning' className='add-only' value='GriefMourning' /> Grief/Mourning</td>
                        <td className='w-187'><input type='checkbox' id='cbAlexithymic' name='cbAlexithymic' className='add-only' value='Alexithymic' /> Alexithymic</td>
                        <td className='w-187'><input type='checkbox' id='cbElated' name='cbElated' className='add-only' value='Elated' /> Elated</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHypomanic' name='cbHypomanic' className='add-only' value='Hypomanic' /> Hypomanic</td>
                        <td className='w-187'><input type='checkbox' id='cbManic' name='cbManic' className='add-only' value='Manic' /> Manic</td>
                        <td className='w-187'><input type='checkbox' id='cbAnxious' name='cbAnxious' className='add-only' value='Anxious' /> Anxious</td>
                        <td className='w-187'><input type='checkbox' id='cbTense' name='cbTense' className='add-only' value='Tense' /> Tense</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMoodOther' name='cbMoodOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtMoodOther' name='txtMoodOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>f. AFFECT</span></td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAppropriate' name='cbAppropriate' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbInappropriate' name='cbInappropriate' className='add-only' value='Inappropriate' /> Inappropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbBlunted' name='cbBlunted' className='add-only' value='Blunted' /> Blunted</td>
                        <td className='w-187'><input type='checkbox' id='cbRestricted' name='cbRestricted' className='add-only' value='Restricted' /> Restricted</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFlat' name='cbFlat' className='add-only' value='Flat' /> Flat</td>
                        <td className='w-187'><input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile</td>
                        <td className='w-187'><input type='checkbox' id='cbTearful' name='cbTearful' className='add-only' value='Tearful' /> Tearful</td>
                        <td className='w-187'><input type='checkbox' id='cbIntense' name='cbIntense' className='add-only' value='Intense' /> Intense</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAffectOther' name='cbAffectOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtAffectOther' name='txtAffectOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>g. PERCEPTUAL DISTURBANCES</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations</td>
                        <td className='w-187'><input type='checkbox' id='cbAuditory' name='cbAuditory' className='add-only' value='Auditory' /> Auditory</td>
                        <td className='w-187'><input type='checkbox' id='cbVisual' name='cbVisual' className='add-only' value='Visual' /> Visual</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOlfactory' name='cbOlfactory' className='add-only' value='Olfactory' /> Olfactory</td>
                        <td className='w-187'><input type='checkbox' id='cbTactile' name='cbTactile' className='add-only' value='Tactile' /> Tactile</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPerceptualDisturbancesOther' name='cbPerceptualDisturbancesOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtPerceptualDisturbancesOther' name='txtPerceptualDisturbancesOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>h. THOUGHT PROCESS</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbLogicalCoherent' name='cbLogicalCoherent' className='add-only' value='LogicalCoherent' /> Logical/Coherent</td>
                        <td className='w-187'><input type='checkbox' id='cbIncomprehensible' name='cbIncomprehensible' className='add-only' value='Incomprehensible' /> Incomprehensible</td>
                        <td className='w-187'><input type='checkbox' id='cbIncoherent' name='cbIncoherent' className='add-only' value='Incoherent' /> Incoherent</td>
                        <td className='w-187'><input type='checkbox' id='cbFlightIdeas' name='cbFlightIdeas' className='add-only' value='FlightIdeas' /> Flight of Ideas</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbLooseAssociations' name='cbLooseAssociations' className='add-only' value='LooseAssociations' /> Loose Associations</td>
                        <td className='w-187'><input type='checkbox' id='cbTangential' name='cbTangential' className='add-only' value='Tangential' /> Tangential</td>
                        <td className='w-187'><input type='checkbox' id='cbCircumstantial' name='cbCircumstantial' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-187'><input type='checkbox' id='cbRambling' name='cbRambling' className='add-only' value='Rambling' /> Rambling</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive</td>
                        <td className='w-187'><input type='checkbox' id='cbRacingThoughts' name='cbRacingThoughts' className='add-only' value='RacingThoughts' /> Racing Thoughts</td>
                        <td className='w-187'><input type='checkbox' id='cbPerseveration' name='cbPerseveration' className='add-only' value='Perseveration' /> Perseveration</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtBlocking' name='cbThoughtBlocking' className='add-only' value='ThoughtBlocking' /> Thought Blocking</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbConcrete' name='cbConcrete' className='add-only' value='Concrete' /> Concrete</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbThoughtProcessOther' name='cbThoughtProcessOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtThoughtProcessOther' name='txtThoughtProcessOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>i. THOUGHT CONTENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPreoccupations' name='cbPreoccupations' className='add-only' value='Preoccupations' /> Preoccupations</td>
                        <td className='w-187'><input type='checkbox' id='cbObsessions' name='cbObsessions' className='add-only' value='Obsessions' /> Obsessions</td>
                        <td className='w-187'><input type='checkbox' id='cbCompulsions' name='cbCompulsions' className='add-only' value='Compulsions' /> Compulsions</td>
                        <td className='w-187'><input type='checkbox' id='cbPhobias' name='cbPhobias' className='add-only' value='Phobias' /> Phobias</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='Delusions' /> Delusions</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtBroadcasting' name='cbThoughtBroadcasting' className='add-only' value='ThoughtBroadcasting' /> Thought Broadcasting</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtInsertion' name='cbThoughtInsertion' className='add-only' value='ThoughtInsertion' /> Thought Insertion</td>
                        <td className='w-187'><input type='checkbox' id='cbThoughtWithdrawal' name='cbThoughtWithdrawal' className='add-only' value='ThoughtWithdrawal' /> Thought Withdrawal</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbIdeasReference' name='cbIdeasReference' className='add-only' value='IdeasReference' /> Ideas of Reference</td>
                        <td className='w-187'><input type='checkbox' id='cbIdeasInfluence' name='cbIdeasInfluence' className='add-only' value='IdeasInfluence' /> Ideas of Influence</td>
                        <td className='w-187'><input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='Delusions' /> Delusions</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbThoughtContentOther' name='cbThoughtContentOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtThoughtContentOther' name='txtThoughtContentOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>j. SUICIDAL/HOMICIDAL THOUGHTS</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSuicidalThoughts' name='cbSuicidalThoughts' className='add-only' value='SuicidalThoughts' /> Suicidal Thoughts</td>
                        <td className='w-187'><input type='checkbox' id='cbSuicidalAttempts' name='cbSuicidalAttempts' className='add-only' value='SuicidalAttempts' /> Suicidal Attempts</td>
                        <td className='w-187'><input type='checkbox' id='cbSuicidalIntent' name='cbSuicidalIntent' className='add-only' value='SuicidalIntent' /> Suicidal Intent</td>
                        <td className='w-187'><input type='checkbox' id='cbSuicidalPlan' name='cbSuicidalPlan' className='add-only' value='SuicidalPlan' /> Suicidal Plan</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHomicidalThoughts' name='cbHomicidalThoughts' className='add-only' value='HomicidalThoughts' /> Homicidal Thoughts</td>
                        <td className='w-187'><input type='checkbox' id='cbHomicidalAttempts' name='cbHomicidalAttempts' className='add-only' value='HomicidalAttempts' /> Homicidal Attempts</td>
                        <td className='w-187'><input type='checkbox' id='cbHomicidalIntent' name='cbHomicidalIntent' className='add-only' value='HomicidalIntent' /> Homicidal Intent</td>
                        <td className='w-187'><input type='checkbox' id='cbHomicidalPlan' name='cbHomicidalPlan' className='add-only' value='HomicidalPlan' /> Homicidal Plan</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHistorySelfInjuriousBehavior' name='cbHistorySelfInjuriousBehavior' className='add-only' value='HistorySelfInjuriousBehavior' /> History of Self-Injurious Behavior</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSucidalThoughtsOther' name='cbSucidalThoughtsOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtSucidalThoughtsOther' name='txtSucidalThoughtsOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>k. SENSORIUM/COGNITION</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAlert' name='cbAlert' className='add-only' value='Alert' /> Alert</td>
                        <td className='w-187'><input type='checkbox' id='cbLethargic' name='cbLethargic' className='add-only' value='Lethargic' /> Lethargic</td>
                        <td className='w-187'><input type='checkbox' id='cbSomnolent' name='cbSomnolent' className='add-only' value='Somnolent' /> Somnolent</td>
                        <td className='w-187'><input type='checkbox' id='cbStuporous' name='cbStuporous' className='add-only' value='Stuporous' /> Stuporous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Oriented to:</b></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPerson' name='cbPerson' className='add-only' value='Person' /> Person</td>
                        <td className='w-187'><input type='checkbox' id='cbPlace' name='cbPlace' className='add-only' value='Place' /> Place</td>
                        <td className='w-187'><input type='checkbox' id='cbTime' name='cbTime' className='add-only' value='Time' /> Time</td>
                        <td className='w-187'><input type='checkbox' id='cbSituation' name='cbSituation' className='add-only' value='Situation' /> Situation</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbNormalConcentration' name='cbNormalConcentration' className='add-only' value='NormalConcentration' /> Normal Concentration</td>
                        <td className='w-187'><input type='checkbox' id='cbImpairedConcentration' name='cbImpairedConcentration' className='add-only' value='ImpairedConcentration' /> Impaired Concentration</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSensoriumOther' name='cbSensoriumOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtSensoriumOther' name='txtSensoriumOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>l. MEMORY</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='checkbox' id='cbImpaired' name='cbImpaired' className='add-only' value='Impaired' /> Impaired</td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Recent Memory: </b></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbRecentNormal' name='cbRecentNormal' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='checkbox' id='cbRecentImpaired' name='cbRecentImpaired' className='add-only' value='Impaired' /> Impaired</td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Immediate Recall: </b></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbImmediateNormal' name='cbImmediateNormal' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='checkbox' id='cbImmediateImpaired' name='cbImmediateImpaired' className='add-only' value='Impaired' /> Impaired</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMemoryOther' name='cbMemoryOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtMemoryOther' name='txtMemoryOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>m. INTELLECTUAL FUNCTIONING</span><span className='small'>(Estimate)</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAboveAvg' name='cbAboveAvg' className='add-only' value='AboveAvg' /> Above Avg</td>
                        <td className='w-187'><input type='checkbox' id='cbNormalAvg' name='cbNormalAvg' className='add-only' value='NormalAvg' /> Normal/Avg</td>
                        <td className='w-187'><input type='checkbox' id='cbBorderline' name='cbBorderline' className='add-only' value='Borderline' /> Borderline</td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Mental Retardation: </b></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMild' name='cbMild' className='add-only' value='Mild' /> Mild</td>
                        <td className='w-187'><input type='checkbox' id='cbModerate' name='cbModerate' className='add-only' value='Moderate' /> Moderate</td>
                        <td className='w-187'><input type='checkbox' id='cbSevere' name='cbSevere' className='add-only' value='Severe' /> Severe</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntellectualOther' name='cbIntellectualOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtIntellectualOther' name='txtIntellectualOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>n. JUDGEMENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbCriticalJudgementIntact' name='cbCriticalJudgementIntact' className='add-only' value='CriticalJudgementIntact' /> Critical Judgement Intact</td>
                        <td className='w-375'><input type='checkbox' id='cbImpairedJudgement' name='cbImpairedJudgement' className='add-only' value='ImpairedJudgement' /> Impaired Judgement</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbJudgementOther' name='cbJudgementOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtJudgementOther' name='txtJudgementOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>o. INSIGHT</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbTrueEmotionalInsight' name='cbTrueEmotionalInsight' className='add-only' value='TrueEmotionalInsight' /> True Emotional Insight</td>
                        <td className='w-187'><input type='checkbox' id='cbIntellectualInsight' name='cbIntellectualInsight' className='add-only' value='IntellectualInsight' /> Intellectual Insight</td>
                        <td className='w-187'><input type='checkbox' id='cbImpairedInsight' name='cbImpairedInsight' className='add-only' value='ImpairedInsight' /> Impaired Insight</td>
                        <td className='w-187'><input type='checkbox' id='cbDenial' name='cbDenial' className='add-only' value='Denial' /> Denial</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSomeAwarenessIllnessSymptoms' name='cbSomeAwarenessIllnessSymptoms' className='add-only' value='SomeAwarenessIllnessSymptoms' /> Some Awareness of illness/symptoms</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbInsightOther' name='cbInsightOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtInsightOther' name='txtInsightOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>p. IMPULSE CONTROL</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbAbleResistImpulses' name='cbAbleResistImpulses' className='add-only' value='AbleResistImpulses' /> Able to Resist Impulses</td>
                        <td className='w-375'><input type='checkbox' id='cbRecentImpulsiveBehavior' name='cbRecentImpulsiveBehavior' className='add-only' value='RecentImpulsiveBehavior' /> Recent Impulsive Behavior</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbImpairedImpulseControl' name='cbImpairedImpulseControl' className='add-only' value='ImpairedImpulseControl' /> Impaired Impulse Control</td>
                        <td className='w-375'><input type='checkbox' id='cbCompulsions' name='cbCompulsions' className='add-only' value='Compulsions' /> Compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbImpulseControlOther' name='cbImpulseControlOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtImpulseControlOther' name='txtImpulseControlOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'>XV. RISK ASSESSMENT: <span className='small'>Assess potential risk of harm to self or others,
                    including patterns of risk behavior and/or risk due to personality factors, substance use, criminogenic factors,
                    exposure to elements, exploitation, abuse, neglect, suicidal and/or homicidal history, self-injury, psychosis, impulsiveness, runaway, etc.</span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. Risk of Harm to Self</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPriorSuicideAttempt' name='cbPriorSuicideAttempt' className='add-only' value='PriorSuicideAttempt' /> Prior Suicide Attempt</td>
                        <td className='w-187'><input type='checkbox' id='cbStatedPlanIntent' name='cbStatedPlanIntent' className='add-only' value='StatedPlanIntent' /> Stated Plan/Intent</td>
                        <td className='w-187'><input type='checkbox' id='cbRecentLoss' name='cbRecentLoss' className='add-only' value='RecentLoss' /> Recent Loss</td>
                        <td className='w-187'><input type='checkbox' id='cbTerminalIllness' name='cbTerminalIllness' className='add-only' value='TerminalIllness' /> Terminal Illness</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSubstance Abuse' name='cbSubstance Abuse' className='add-only' value='Substance Abuse' /> Substance Abuse</td>
                        <td className='w-187'><input type='checkbox' id='cbPsychosis' name='cbPsychosis' className='add-only' value='Psychosis' /> Psychosis</td>
                        <td className='w-187'><input type='checkbox' id='cbFamilyHistorySuicide' name='cbFamilyHistorySuicide' className='add-only' value='FamilyHistorySuicide' /> Family History of Suicide</td>
                        <td className='w-187'><input type='checkbox' id='cbMarkedLackSupport' name='cbMarkedLackSupport' className='add-only' value='MarkedLackSupport' /> Marked Lack of support</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbAccessMean' name='cbAccessMean' className='add-only' value='AccessMean' /> Access to Mean (weapons, pills, etc.)</td>
                        <td className='w-375'><input type='checkbox' id='cbSuicideFriendAcquaintance' name='cbSuicideFriendAcquaintance' className='add-only' value='SuicideFriendAcquaintance' /> Suicide of friend/acquaintance</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPresenceBehavioralCues' name='cbPresenceBehavioralCues' className='add-only' value='PresenceBehavioralCues' /> Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc.)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHarmToSelfOther' name='cbHarmToSelfOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtHarmToSelfOther' name='txtHarmToSelfOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. Risk of Harm to Others</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPriorActsViolence' name='cbPriorActsViolence' className='add-only' value='PriorActsViolence' /> Prior acts of violence</td>
                        <td className='w-187'><input type='checkbox' id='cbDestructionProperty' name='cbDestructionProperty' className='add-only' value='DestructionProperty' /> Destruction of property</td>
                        <td className='w-187'><input type='checkbox' id='cbArrestsViolence' name='cbArrestsViolence' className='add-only' value='ArrestsViolence' /> Arrests of violence</td>
                        <td className='w-187'><input type='checkbox' id='cbSubstanceAbuse' name='cbSubstanceAbuse' className='add-only' value='SubstanceAbuse' /> Substance Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbHarmsAnimals' name='cbHarmsAnimals' className='add-only' value='HarmsAnimals' /> Harms animals</td>
                        <td className='w-187'><input type='checkbox' id='cbFireStarting' name='cbFireStarting' className='add-only' value='FireStarting' /> Fire Starting</td>
                        <td className='w-187'><input type='checkbox' id='cbAngryMoodAgitation' name='cbAngryMoodAgitation' className='add-only' value='AngryMoodAgitation' /> Angry mood/agitation</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbAccessToMean' name='cbAccessToMean' className='add-only' value='AccessToMean' /> Access to Mean (weapons)</td>
                        <td className='w-375'><input type='checkbox' id='cbPhysicallyAbusedChild' name='cbPhysicallyAbusedChild' className='add-only' value='PhysicallyAbusedChild' /> Physically Abused as a child</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='PhysicallyAbusiveChild' name='PhysicallyAbusiveChild' className='add-only' value='PhysicallyAbusiveChild' /> Was physically abusive as a child</td>
                        <td className='w-375'><input type='checkbox' id='cbPriorHospitalizations' name='cbPriorHospitalizations' className='add-only' value='PriorHospitalizations' /> Prior hospitalizations for danger to others</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbPsychosisHallucinations' name='cbPsychosisHallucinations' className='add-only' value='PsychosisHallucinations' /> Psychosis/command hallucinations</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHarmToOthersOther' name='cbHarmToOthersOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtHarmToOthersOther' name='txtHarmToOthersOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>c. Client Safety & Other Risk Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbFeelsUnsafeLivingEnvironment' name='cbFeelsUnsafeLivingEnvironment' className='add-only' value='FeelsUnsafeLivingEnvironment' /> Feels unsafe in the current living environment</td>
                        <td className='w-375'><input type='checkbox' id='cbEngagesDangerousSexualBehavior' name='cbEngagesDangerousSexualBehavior' className='add-only' value='EngagesDangerousSexualBehavior' /> Engages in dangerous sexual behavior</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRelapseDecompensationTriggers' name='cbRelapseDecompensationTriggers' className='add-only' value='RelapseDecompensationTriggers' /> Relapse/decompensation of triggers</td>
                        <td className='w-375'><input type='checkbox' id='cbRunaway' name='cbRunaway' className='add-only' value='Runaway' /> Runaway</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbFeelsCurrentlyBeingHarmed' name='cbFeelsCurrentlyBeingHarmed' className='add-only' value='FeelsCurrentlyBeingHarmed' /> Feels currently being harmed/hurt/abused/threatened by someone</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPastInvolvement' name='cbPastInvolvement' className='add-only' value='PastInvolvement' /> Past Involvement with Child or Adult Protective Services</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClientSafetyOther' name='cbClientSafetyOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtClientSafetyOther' name='txtClientSafetyOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>d. <span className='eleHeader'>Describe Recipient's preferences and desires for addressing risk factors, including any Mental Health Advance Directives or plan of response to periods of decompensation/relapse</span>
                    <span className='small'>(Ex. Resources the Recipient feels comfortable reaching out to for assistance in a crisis)</span>
                    <textarea id='txtDescribeRecipient' name='txtDescribeRecipient' className='add-only'></textarea>
                </p>

                <p className='w-750'>XVI. STRENGTHS/SUPPORTS/RESOURCES: </p>
                <p className='w-750'><span className='eleHeader'>Recipient's strength, abilities, and interests</span>
                    <textarea id='txtStrengthsResources' name='txtStrengthsResources' className='add-only'></textarea>
                </p>


                <p className='w-750'><span className='eleHeader'>Supports and resources available to the Recipient <span className='small'>(including natural supports):</span></span>
                    <textarea id='txtResourcesAvailable' name='txtResourcesAvailable' className='add-only'></textarea>
                </p>



                <p className='w-750'>XVII. CULTURAL AND LANGUAGE PREFERENCES <span className='small'>(language, customs/values/preferences)</span></p>
                <p className='w-750'><span className='eleHeader'>a. Spiritual Beliefs/Preferences</span>
                    <textarea id='txtCultureLanguage' name='txtCultureLanguage' className='add-only'></textarea>
                </p>


                <p className='w-750'><span className='eleHeader'>b. Cultural Beliefs/Preferences </span>
                    <textarea id='txtCulturalBeliefs' name='txtCulturalBeliefs' className='add-only'></textarea>
                </p>

                <p className='w-750'>XVIII. INITIAL DIAGNOSTIC IMPRESSION </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>IDC10 CODE:</span></td>
                        <td className='w-500'><span className='eleHeader'>DESCRIPTION </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtCode_1' name='txtCode_1' className='add-only' /></td>
                        <td className='w-500'><input type='text' id='txtDescription_1' name='txtDescription_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtCode_2' name='txtCode_2' className='add-only' /></td>
                        <td className='w-500'><input type='text' id='txtDescription_2' name='txtDescription_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>XIX. INTERPRETATIVE SUMMARY <span className='small'>
                    <b>*COMMENT SECTION MUST BE COMPLETED:</b> Please give a review of the entire assessment, i.e., Recipient's name, age, reason for referral,
                    presenting problem, presenting symptoms, problem behaviors, family info, etc. Describe Recipient's global preferences/hopes for recovery,
                    recommended treatments/assessment, level of care, duration.
                </span></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. Recommended Services: </span><span className='small'>(Check all that apply)</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbFamilyTherapy' name='cbFamilyTherapy' className='add-only' value='FamilyTherapy' /> Family Therapy</td>
                        <td className='w-187'><input type='checkbox' id='cbIndividualTherapy' name='cbIndividualTherapy' className='add-only' value='IndividualTherapy' /> Individual Therapy</td>
                        <td className='w-187'><input type='checkbox' id='cbGroupTherapy' name='cbGroupTherapy' className='add-only' value='GroupTherapy' /> Group Therapy</td>
                        <td className='w-187'><input type='checkbox' id='cbPsr' name='cbPsr' className='add-only' value='Psr' /> PSR</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCpst' name='cbCpst' className='add-only' value='Cpst' /> CPST</td>
                        <td className='w-375'><input type='checkbox' id='cbAlcoholDrugIndividualTherapy' name='cbAlcoholDrugIndividualTherapy' className='add-only' value='AlcoholDrugIndividualTherapy' /> Alcohol/Drug Individual Therapy</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbMedicationManagement' name='cbMedicationManagement' className='add-only' value='MedicationManagement' /> Medication Management</td>
                        <td className='w-375'><input type='checkbox' id='cbAlcoholDrugAssessment' name='cbAlcoholDrugAssessment' className='add-only' value='AlcoholDrugAssessment' /> Alcohol/Drug Assessment</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. Other Services/Linkages Needed </span><span className='small'>(Check all that apply)</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbVocationalServices' name='cbVocationalServices' className='add-only' value='VocationalServices' /> Vocational Services</td>
                        <td className='w-187'><input type='checkbox' id='cbSocialServices' name='cbSocialServices' className='add-only' value='SocialServices' /> Social Services</td>
                        <td className='w-187'><input type='checkbox' id='cbEducationalServices' name='cbEducationalServices' className='add-only' value='EducationalServices' /> Educational Services</td>
                        <td className='w-187'><input type='checkbox' id='cbMedicalServices' name='cbMedicalServices' className='add-only' value='MedicalServices' /> Medical Services</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPcp' name='cbPcp' className='add-only' value='Pcp' /> PCP</td>
                        <td className='w-187'><input type='checkbox' id='cbSelfHelpGroups' name='cbSelfHelpGroups' className='add-only' value='SelfHelpGroups' /> Self Help Groups</td>
                        <td className='w-187'><input type='checkbox' id='cbCrisisStabilizations' name='cbCrisisStabilizations' className='add-only' value='CrisisStabilizations' /> Crisis Stabilizations</td>
                        <td className='w-187'><input type='checkbox' id='cbCsocServices' name='cbCsocServices' className='add-only' value='CsocServices' /> CSoC Services</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbLinkagesNeededOther' name='cbLinkagesNeededOther' className='add-only' value='Other' /> Other/Describe :
                            <input type='text' id='txtLinkagesNeededOther' name='txtLinkagesNeededOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>c. Recipient's Goals</span><span className='small'>(The goals must be in the Recipient's own words.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>1. <input type='text' id='txtRecipientGoals_1' name='txtRecipientGoals_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>2. <input type='text' id='txtRecipientGoals_2' name='txtRecipientGoals_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>3. <input type='text' id='txtRecipientGoals_3' name='txtRecipientGoals_3' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>*Additional Comments:</b>
                    <textarea id='txtGoalsComments' name='txtGoalsComments' className='add-only'></textarea></p>
                <p className='w-750'>
                    <center>
                        <b>SIGNATURE</b></center>
                </p>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>PRINTED NAME OF ASSESSOR </span></td>
                        <td className='w-375'><span className='eleHeader'>SIGNATURE</span></td>
                    </tr><tr>
                        <td className='w-375'><input type='text' id='txtSignatureName' name='txtSignatureName' className='add-only' /></td>
                        <td className='signature w-350'></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>LMHP STATUS </span></td>
                        <td className='w-375'><span className='eleHeader'>DATE</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtSignatureLmphStatus' name='txtSignatureLmphStatus' className='add-only' /></td>
                        <td className='w-375'><input type='date' id='txtSignatureDate' name='txtSignatureDate' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-500'> </td>
                        <td className='signature w-250'> </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Recipient: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'> </td>
                        <td className='signature w-250'> </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent/Guardian: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'> </td>
                        <td className='signature w-250'> </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Provider: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'> </td>
                        <td className='signature w-250'> </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Therapist/Counselor: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                </table>









            </div>
        </form>

    )
}











